import { useCallback } from "react";
import { ActionIcon, Tooltip, useMantineColorScheme } from "@mantine/core";
import { IconSun, IconMoon, IconDeviceDesktop } from "@tabler/icons-react";

type Scheme = "light" | "dark" | "auto";

const CYCLE: Scheme[] = ["light", "dark", "auto"];

export const THEME_ICON: Record<Scheme, React.ElementType> = {
  light: IconSun,
  dark: IconMoon,
  auto: IconDeviceDesktop,
};

export const THEME_LABEL: Record<Scheme, string> = {
  light: "Light mode",
  dark: "Dark mode",
  auto: "System theme",
};

export function useThemeCycle() {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const current = (CYCLE.includes(colorScheme as Scheme) ? colorScheme : "auto") as Scheme;

  const cycle = useCallback(() => {
    const next = CYCLE[(CYCLE.indexOf(current) + 1) % CYCLE.length];
    if (next) setColorScheme(next);
  }, [current, setColorScheme]);

  return { current, cycle };
}

export function ThemeButton() {
  const { current, cycle } = useThemeCycle();
  const Icon = THEME_ICON[current];

  return (
    <Tooltip label={THEME_LABEL[current]}>
      <ActionIcon variant="transparent" c="inherit" onClick={cycle} size={42}>
        <Icon stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
